"use strict";

const Touchscreen = () => {
    const init = () => {
        $(function() {
            var $touchscreenVideo = $('.js-touchscreen-splash-video');
            if($touchscreenVideo.length){
                var $video = $touchscreenVideo.find('video');
                var lastWidth = 0;
                $(window).on('resize', function() {
                    if($(window).outerWidth() < 1200){
                        if(lastWidth == 0 || lastWidth >= 1200){
                            $video.css('width', Math.max($touchscreenVideo.outerWidth(), $touchscreenVideo.outerHeight()*1920/1080)+'px');
                            $video.css('height', Math.max($touchscreenVideo.outerHeight(), $touchscreenVideo.outerWidth()*1080/1920)+'px');
                            lastWidth = $(window).outerWidth();
                            $video.find('source').attr('src', $video.data('portrait'));
                            $video[0].load();
                            $video[0].play();
                        }
                    }else{
                        if(lastWidth < 1200){
                            lastWidth = $(window).outerWidth();
                            $video.css('width', Math.max($touchscreenVideo.outerWidth(), $touchscreenVideo.outerHeight()*1080/1920)+'px');
                            $video.css('height', Math.max($touchscreenVideo.outerHeight(), $touchscreenVideo.outerWidth()*1920/1080)+'px');
                            $video.find('source').attr('src', $video.data('landscape'));
                            $video[0].load();
                            $video[0].play();
                        }
                    }
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Touchscreen;